import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import ButtonZegel from "../../../components/Buttons/ButtonZegel";
import InputPastZegel from "../../../components/Inputs/InputPassZegel";
import InputZegel from "../../../components/Inputs/InputZegel";
import useAlumno from "../../../hooks/useAlumno";
import { PrivateRoutes, PublicRoutes } from "../../../routes/routes";
import zegelVirtual from "../../../assets/img/zegelVirtual.png";

import "../styles/Login.scss";

function FormLogin() {
    const navigate = useNavigate();
    const [errorLogin, setErrorLogin] = useState(null);
    const [errorContrasena, setErrorContrasena] = useState(null);
    const [errorUsuario, setErrorUsuario] = useState(null);
    const { login, isLogged, hasLoginError, hasMesageError } = useAlumno();

    const schema = Yup.object().shape({
        correo: Yup.string().required("Correo es un campo obligatorio"),
        password: Yup.string().required("Contraseña es un campo obligatorio"),
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            correo: "",
            password: "",
        },
        validationSchema: schema,
        onSubmit: (values) => {
            let userName = values.correo;
            let password = values.password;
            Logarse({ userName, password });
        },
    });

    const Logarse = async ({ userName, password }) => {
        try {
            await login({ userName, password }, setErrorLogin);
        } catch (error) {
        }
    };

    const handleOpenRecuperar = () => navigate("/" + PublicRoutes.RECUPERAR);

    useEffect(() => {
        if (hasMesageError) {
            let tempArray = hasMesageError.split("|")
            if (tempArray.length > 0) {
                if (tempArray[0] == "1") {
                    setErrorUsuario(tempArray[1]);
                    setErrorContrasena(null)
                }
                if (tempArray[0] == "2") {
                    setErrorUsuario(null)
                    setErrorContrasena(tempArray[1]);
                }
            }
        }
    }, [hasMesageError]);

    useEffect(() => {
        if (errorLogin) {
            formik.setSubmitting(false);
            setErrorLogin(false);
        }
    }, [errorLogin]);

    useEffect(() => {
        if (isLogged) navigate("/" + PrivateRoutes.HOME + "/" + PrivateRoutes.DASHBOARD);
    }, [isLogged]);

    useEffect(()=>{
        window.sessionStorage.clear();
    })

    return (
        <div className="grid justify-content-center">
            <div className="lf-logo flex align-items-center justify-content-center">
                <img
                    src={zegelVirtual}
                    height={"74px"}
                    style={{ marginTop: "25vh", marginBottom: 29, height: 100 }}
                ></img> 
            </div>
            <form onSubmit={formik.handleSubmit}>

                <div className="lf-credenciales formgrid grid justify-content-center ">
                    <div className="field col-12 md:col-12 mb-5 mt-5">
                        <div className="p-float-label">
                            <InputZegel
                                id="correo"
                                name="correo"
                                value={formik.values.correo}
                                style={{ width: "100%", height: 50 }}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            <label
                                htmlFor="correo"
                                style={{ fontSize: 14, color: "#c4c4c4" }}
                            >
                                Correo electrónico
                            </label>
                        </div>
                        <small className="p-error">
                            {formik.touched.correo && formik.errors.correo}
                            {errorUsuario && errorUsuario}
                        </small>
                    </div>
                    <div className="field col-12 md:col-12">
                        <div className="p-float-label">
                            <InputPastZegel
                                id="password"
                                name="password"
                                value={formik.values.password}
                                style={{ width: "100%", height: 50 }}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            <label
                                htmlFor="pass"
                                style={{ fontSize: 14, color: "#c4c4c4" }}
                            >
                                Contraseña
                            </label>
                        </div>
                        <small className="p-error">
                            {formik.touched.password && formik.errors.password}
                            {!(formik.touched.password && formik.errors.password) && errorContrasena && errorContrasena}
                        </small>
                    </div>
                    <div className="field col-12 md:col-12 mt-3">
                        <ButtonZegel
                            label="Ingresar"
                            color="primary"
                            type="submit"
                            loading={formik.isSubmitting}
                        ></ButtonZegel>
                    </div>
                    <div className="field col-12 md:col-12 mt-3 text-center">
                        <span className="link-zad" onClick={handleOpenRecuperar}>
                            ¿Olvidaste tu contraseña?
                        </span>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default FormLogin